import React from 'react';
import { Button, Form, TimePicker, Select, DatePicker } from 'antd';
import { AddExamRoutineFormWrapper } from './examRoutine.style';
import { useSubject } from 'features/result/hooks/useSubject';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useGrade } from '../../routine/hooks/useGrade';
import moment from 'moment';
import { useExamRoutine } from '../hooks/useExamRoutine';

export const AddExamRoutineForm = (props: any) => {
  const { onVisibleChange, onSetReloadExamRoutine, grade, examType, examYear } = props;
  const [form] = Form.useForm();
  const { fetchSubject } = useSubject();
  const { publishExamRoutine } = useExamRoutine();
  const subjects = useSelector((state: RootState) => state.subject);
  const [endValue, setEndValue] = React.useState('');
  const [startValue, setStartValue] = React.useState('');
  const [dateValue, setDateValue] = React.useState('');

  React.useEffect(() => {
    fetchSubject();

    //eslint-disable-next-line
  }, []);

  return (
    <AddExamRoutineFormWrapper>
      <Form form={form} name="nest-messages" layout="vertical" size="large">
        <div className="time">
          <Form.Item label="Start Time" name="start">
            <TimePicker
              bordered={false}
              size="small"
              format="HH:mm "
              onChange={(date) => setStartValue(moment(date).format('HH:mm'))}
              value={startValue !== '' ? moment(startValue, 'HH:mm') : null}
              style={{ padding: '0px', border: '0px', width: '200px' }}
            />
          </Form.Item>
          <Form.Item label="End Time" name="end">
            <TimePicker
              bordered={false}
              size="small"
              format="HH:mm "
              onChange={(date) => setEndValue(moment(date).format('HH:mm'))}
              value={endValue !== '' ? moment(endValue, 'HH:mm') : null}
              style={{ padding: '0px', border: '0px', width: '200px' }}
            />
          </Form.Item>

          <Form.Item label="Date" name="date">
            <DatePicker
              bordered={false}
              size="small"
              onChange={(date) => setDateValue(moment(date).format('YYYY-MM-DD'))}
              value={dateValue !== '' ? moment(dateValue, 'YYYY-MM-DD') : null}
              style={{ padding: '0px', border: '0px', width: '200px' }}
            />
          </Form.Item>
        </div>
        <Form.Item label="Grade" name={'gradeId'}>
          <Select defaultValue="Select Grade">
            {grade.map((item: any) => (
              <Select.Option value={item.id}>{item.id}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Subject" name={'subjectId'}>
          <Select defaultValue="Select Subject">
            {subjects.data.map((item) => (
              <Select.Option value={item.id}>{item.title}</Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Exam Type" name={'examTypeId'}>
          <Select defaultValue="Select Exam Type">
            {examType.map((item: any) => (
              <Select.Option value={item.id}>{item.id}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Exam Year" name={'examYearId'}>
          <Select defaultValue="Select Exam Year">
            {examYear.map((item: any) => (
              <Select.Option value={item.id}>{item.id}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item hidden={true}></Form.Item>
        <Form.Item>
          <Button
            htmlType="submit"
            onClick={() => {
              publishExamRoutine(
                {
                  ...form.getFieldsValue(),
                  end: endValue,
                  start: startValue,
                  date: dateValue,
                },
                form,
                onVisibleChange,
                onSetReloadExamRoutine,
              );
            }}
          >
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddExamRoutineFormWrapper>
  );
};

export default AddExamRoutineForm;
